/**
 * List of URL search params to exclude from filters processing.
 * - This is a custom list specific to the project,
 * - The generic one should be in `src/utils/base/urls.ts` `URL_TRACKING_PARAMS`
 */
export const URL_CUSTOM_EXCLUSION_PARAMS: string[] = [
  'q',
  'modal'
]
